import { useCallback, useEffect } from "react";
import { useNavigationModule } from "@agp/shared.user-app/application/context/navigation";
import { motion } from "motion/react";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";

export const MinpakuSplashPage = () => {
  const { push } = useNavigationModule();

  const handleClick = useCallback(() => {
    push("top", {
      pageInType: "fade",
      pageOutType: "fade",
    });
  }, []);

  useEffect(() => {
    const timer = async () => {
      await delay(3000);
      handleClick();
    };
    timer();
  }, []);

  return (
    <AnimatedPageTransition>
      <div
        className="bg-white h-[calc(var(--vh,1vh)*100)] flex flex-col justify-center items-center"
        onClick={handleClick}
      >
        <motion.img
          src="/minpaku-demo/logos/acoustiguide.png"
          // initial={{ scale: 0.8 }}
          // animate={{ scale: 1 }}
          // transition={{ duration: 1.5 }}
          className="w-[75%]"
        />
      </div>
    </AnimatedPageTransition>
  );
};

const delay = (milliseconds: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, milliseconds);
  });
